<template>
    <div class="v-icon mr-2 ">
        <v-btn
            @click="editDialog(personId)"
            class="info"
        >
            Edit
        </v-btn>
        <v-dialog
            :value="editPersonAddressDialog"
            max-width="700px"
            persistent
        >
            <v-card v-if="editPersonAddressDialog">
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Edit Person Address</span>
                    <v-spacer />
                    <v-btn
                        @click.stop="closeEditItem()"
                        fab
                        rounded
                        small
                        text
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container
                        grid-list-md
                        pt-0
                    >
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editAddressLineOneErrors"
                                    @blur="$v.editAddressLineOne.$touch()"
                                    @input="$v.editAddressLineOne.$touch()"
                                    label="Address Line One"
                                    type="text"
                                    v-model="editAddressLineOne"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Address Line Two"
                                    type="text"
                                    v-model="editAddressLineTwo"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Town"
                                    type="text"
                                    v-model="editTown"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="County"
                                    type="text"
                                    v-model="editCounty"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editPostCodeErrors"
                                    @blur="$v.editPostCode.$touch()"
                                    @input="$v.editPostCode.$touch()"
                                    label="Postcode"
                                    type="text"
                                    v-model="editPostCode"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :items="personnelCountryList"
                                    item-text="name"
                                    item-value="personnelCountryId"
                                    label="Country"
                                    v-model="editPersonnelCountryId"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Logitude"
                                    type="text"
                                    v-model="editLongitude"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Latitude"
                                    type="text"
                                    v-model="editLatitude"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editEmailAddressPersonalErrors"
                                    @blur="$v.editEmailAddressPersonal.$touch()"
                                    @input="$v.editEmailAddressPersonal.$touch()"
                                    label="Email Address (Personal)"
                                    type="text"
                                    v-model="editEmailAddressPersonal"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    counter
                                    label="Comments"
                                    maxlength="90"
                                    type="text"
                                    v-model="editComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveEditItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeEditItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    import { SET_EDIT_PERSON_FORM_SECTION_STATE } from "@/store/person/mutations";
import { FETCH_PERSON_ADDRESS, SAVE_PERSON_ADDRESS } from "@/store/person_address/actions.js";
import { LOAD_PERSON_ADDRESS_TO_EDIT, RESET_DEFAULT_PERSON_ADDRESS_TO_EDIT, TOGGLE_EDIT_PERSON_ADDRESS_DIALOG, UPDATE_PERSON_ADDRESS_FIELD } from "@/store/person_address/mutations.js";

    import { email, required } from 'vuelidate/lib/validators';

    export default {
        name: "EditPersonAddressDialog",

        validations: {
            editAddressLineOne: {required},
            editPostCode: {required},
            editEmailAddressPersonal: {email},
        },

        components: {},

        mixins: [
            EditTableFunctions,
        ],


        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                // Required for editTableFunctions
                idName: 'personAddressId',
            }
        },

        computed: {
            editAddressLineOne: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.addressLineOne;
                },
                set(value) {
                    this.updatePersonAddress('addressLineOne', value);
                }
            },
            editAddressLineOneErrors() {
                const errors = [];
                if (!this.$v.editAddressLineOne.$dirty) return errors;
                !this.$v.editAddressLineOne.required && errors.push('required.');
                return errors
            },
            editAddressLineTwo: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.addressLineTwo;
                },
                set(value) {
                    this.updatePersonAddress('addressLineTwo', value);
                }
            },
            editTown: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.town;
                },
                set(value) {
                    this.updatePersonAddress('town', value);
                }
            },
            editCounty: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.county;
                },
                set(value) {
                    this.updatePersonAddress('county', value);
                }
            },
            editPostCode: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.postCode;
                },
                set(value) {
                    this.updatePersonAddress('postCode', value);
                }
            },
            editPostCodeErrors() {
                const errors = [];
                if (!this.$v.editPostCode.$dirty) return errors;
                !this.$v.editPostCode.required && errors.push('required.');
                return errors
            },
            editLongitude: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.longitude;
                },
                set(value) {
                    this.updatePersonAddress('longitude', value);
                }
            },
            editLatitude: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.latitude;
                },
                set(value) {
                    this.updatePersonAddress('latitude', value);
                }
            },
            editPersonnelCountryId: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.personnelCountryId;
                },
                set(value) {
                    this.updatePersonAddress('personnelCountryId', value);
                }
            },
            editEmailAddressPersonal: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.emailAddressPersonal;
                },
                set(value) {
                    this.updatePersonAddress('emailAddressPersonal', value);
                }
            },
            editEmailAddressPersonalErrors() {
                const errors = [];
                if (!this.$v.editEmailAddressPersonal.$dirty) return errors;
                !this.$v.editEmailAddressPersonal.email && errors.push('Must be a valid email address.');
                return errors
            },
            editComments: {
                get() {
                    return this.$store.state.person_address.editPersonAddress.comments;
                },
                set(value) {
                    this.updatePersonAddress('comments', value);
                }
            },
            ...mapGetters(
            [
                "editPersonAddressDialog",
                "editFeedback",
                "statusList",
                "personnelCountryList",
                "applicationTypeNameById",
                "feedbackTypeNameById",
                "statusNameById",
                "editPersonFormState",
            ]
            ),
            ...mapGetters({
                id: "editPersonAddressId"
            })
        },

        mounted() {
            this.fetchPersonAddress();
        },


        methods: {
            validate() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }


                this.$store.commit(SET_EDIT_PERSON_FORM_SECTION_STATE, {section: 'address', state: formState});
            },

            async validateAll() {

                const results = Promise.all([
                    this.validate(),
                ]);

                await results;

                let resultsArray = [];

                resultsArray.push(this.editPersonFormState('address'));

                const areValid = resultsArray.every((result) => {
                    return result == 'complete';
                });

                return areValid;
            },

            fetchPersonAddress() {
                this.$store.dispatch(FETCH_PERSON_ADDRESS, this.personId);
            },

            updatePersonAddress(field, value) {
                let data = {};
                data.field = field;
                data.value = value;
                this.$store.commit(UPDATE_PERSON_ADDRESS_FIELD, data);
            },
            // updatePersonSummary() {
            //     this.$store.dispatch(UPDATE_PERSON_ADDRESS)
            // },
            toggleEditPersonSummaryDialog() {
                this.$store.commit(TOGGLE_EDIT_PERSON_ADDRESS_DIALOG);
            },
            ...mapActions({
                fetchItem: FETCH_PERSON_ADDRESS,
                updateTableItemRecord: SAVE_PERSON_ADDRESS,
            }),
            //
            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_ADDRESS_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_ADDRESS_TO_EDIT,
                // updateTableItemToEdit: ,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_ADDRESS_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
